<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App',
  async created() {

  },
};
</script>

<style scoped>

</style>
